@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-toolbar>
  <mat-icon mat-list-icon>business</mat-icon>
  <span class="container-fluid">
    <h1>
      {{ 'USER_MANAGEMENT.ADD_ORGANIZATION' | transloco }}
    </h1>
  </span>
</mat-toolbar>

<mat-dialog-content class="mt-3">
  <form [formGroup]="organizationForm" (ngSubmit)="saveChanges()">
    <!-- Organization Name -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>
        {{ 'USER_MANAGEMENT.ORGANIZATION_NAME' | transloco }}
      </mat-label>
      <input matInput [placeholder]="'USER_MANAGEMENT.ORGANIZATION_NAME' | transloco" formControlName="name">
      <mat-icon matSuffix>business</mat-icon>
      @if (organizationForm.get('name')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.ORGANIZATION_NAME' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label class="label-margin-left">
        {{ 'USER_MANAGEMENT.ORGANIZATION_TYPE' | transloco }}
      </mat-label>
      <mat-select formControlName="type">
        @for (type of organizationTypes; track type) {
          <mat-option [value]="type">
            {{type}}
          </mat-option>
        }
      </mat-select>
      @if (organizationForm.get('type')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.ORGANIZATION_TYPE' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" [align]="'end'">
  <button mat-button mat-dialog-close>{{ 'PRICING.FORM.CANCEL' | transloco }}</button>
  <button mat-button mat-raised-button color="primary" type="submit" (click)="saveChanges()">
    {{ 'USER_MANAGEMENT.SAVE_CHANGES' | transloco }}
  </button>
</mat-dialog-actions>